import React from 'react';
import PropTypes from 'prop-types';

const BasicProgressBar = (props) => {
     if (props.total === 0) { return <div />; }

    let {total, completed, partial = 0} = props;

    if (total > props.cutoff) {
        completed = Math.floor((completed / props.total) * props.cutoff);
        partial = Math.floor((partial / props.total) * props.cutoff);
        total = props.cutoff;
    }

    let segments = [];
    for (let i = 0; i < completed; i++) {
        segments.push(
            <div key={i} className="segment completed">
                {!!props.link && <a href={props.link} />}
            </div>
        );
    }

    if (partial) {
        partial += completed;
        for (let i = completed; i < partial; ++i) {
            segments.push(
                <div key={i} className="segment partial">
                    {!!props.link && <a href={props.link} />}
                </div>
            );
        }
    }

    for (let i = (partial || completed); i < total; i++) {
        segments.push(
            <div key={i} className="segment none">
                {!!props.link && <a href={props.link} />}
            </div>
        );
    }

    return (
        <div key="progressBar" className={`progressBar ${props.className|| ''} ${props.success ? 'success' : ''}`} >
            {segments}
        </div>
    )

};

BasicProgressBar.propTypes = {
    total: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
    partial: PropTypes.number,
    success: PropTypes.bool,

    className: PropTypes.string,
    link: PropTypes.string,
    cutoff: PropTypes.number,
};

BasicProgressBar.defaultProps = ({
    success: false,
    cutoff: 100
});



export default BasicProgressBar;

